import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnChanges,
  SimpleChanges,
} from '@angular/core';
import { LinkRowLink } from './link-row.model';

/**
 * Row of links normally used in conjunction with section head and/or carousels
 * such as "View All" but can also accept multiple links.
 *
 * Example:
 * <dgx-link-row
 *    links="[
 *      { 'label': 'View All', 'url': 'learning#/browse?type=top' },
 *      { 'label': 'Do Something', 'onClick': doSomething($event) }
 *    ]"
 * >
 * </dgx-link-row>
 *
 * Using the routerLink:
 * <dgx-link-row
 *    links="[
 *      { 'label': 'View All', 'routerLink': ['details', '1234', 'Tag', '/5/'] },
 *    ]"
 * >
 * </dgx-link-row>
 *
 * @param links array of LinkRowLink objects
 */
@Component({
    selector: 'dgx-link-row',
    templateUrl: './link-row.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class LinkRowComponent implements OnChanges {
  @Input() public links: LinkRowLink[] = [];

  public ngOnChanges({ links }: SimpleChanges): void {
    if (links?.currentValue?.length) {
      for (const link of links.currentValue) {
        if (!link.url) {
          link.role = 'button';
        }
      }
    }
  }
}
